<template>
    <el-form label-position="top" :model="user" ref="userForm" :rules="formRule" label-width="100px">
        <el-form-item :label="$t('userManager.userName')" prop="userName">
            <el-input v-model="user.userName" maxlength="60" :show-word-limit="true" style="width: 300px;" clearable :placeholder="$t('userManager.userNameRequired')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('userManager.email')" prop="email">
            <el-input v-model="user.email" maxlength="33" :show-word-limit="true" style="width: 300px;" clearable :placeholder="$t('userManager.emailRequired')"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="updateProfile">{{$t('commons.save')}}</el-button>
        </el-form-item>
    </el-form>
</template>
<script>
import {validateEmail} from '@/utils/validate'
let manager = require("@/api/business/sso/personal/personal.js")

export default {
    data() {
        return {
            user: {
                userAccount: this.$store.getters.userAccount,
                userName: null,
                email: null
            },
            formRule: {
                userName: [{
                    required: true,
                    trigger: ['blur', 'change'],
                    message: this.$t('validate.required')
                }],
                email: [{
                    required: false,
                    trigger: ['blur', 'change'],
                    message: this.$t('validate.required')
                    },{
                    validator: (rule, value, callback) =>{
                        if(value && !validateEmail(value)) {
                            callback(new Error(this.$t('validate.invalidEmail')));
                        }
                        callback();
                    },
                    trigger: ['blur', 'change']
                }]
            }
        }
    },
    props: {
        currentUser: {
            type: Object
        }
    },
    created() {
        this.user.userName = this.currentUser.userName
        this.user.email = this.currentUser.email
    },
    methods: {
        updateProfile() {
            this.$refs.userForm.validate(v=> {
                if(v) {
                    manager.updateProfile(this.user).then(r=> {
                        if(r > 0) {
                            this.$message({type: 'success', message: this.$t('message.updateSuccess')});
                        } else {
                            this.$message({type: 'error', message: this.$t('message.updateFail')});
                        }
                    })
                }
            })
        },
    }
}
</script>
